<template>
  <v-layout>
    <v-flex
      xs10="user.permissao === 0"
      xs12="user.permissao !== 0"
      class="v-chip-link">
      <v-chip
        color="indigo"
        style="font-weight: 900"
        dark
        small
        @click="go('/empresa')"
      >
        {{ strings[idioma].inicio }}
      </v-chip>
      <v-chip
        v-if="Cargos.length > 0"
        color="indigo"
        dark
        small
        @click="go('/empresa/colaboradores')"
      >
        {{ strings[idioma].colaboradores }}
      </v-chip>
      <v-chip
        v-if="Cargos.length > 0 && empresa.parceiro === 1"
        color="indigo"
        dark
        small
        @click="go('/empresa/parceiros')"
      >
        {{ strings[idioma].gerenciar_parceria }}
      </v-chip>
      <v-chip
        v-if="Cargos.length > 0"
        color="indigo"
        dark
        small
        @click="go('/empresa/clientes')"
      >
        {{ strings[idioma].clientes }}
      </v-chip>
      <v-chip
        v-if="(user.emp_user && user.emp_user.acesso === 0) || user.permissao === 0"
        color="indigo"
        dark
        small
        @click="go('/empresa/alimentos')"
      >
        {{ strings[idioma].produtos }}
      </v-chip>
      <v-chip
        color="indigo"
        dark
        small
        @click="go('/empresa/relatorios')"
      >
        {{ strings[idioma].relatorios }}
      </v-chip>
      <v-chip
        v-if="(user.emp_user && user.emp_user.acesso === 0) || user.permissao === 0"
        color="indigo"
        dark
        small
        @click="go('/empresa/editar')"
      >
        {{ strings[idioma].editar_empresa }}
      </v-chip>
    </v-flex>
    <v-flex
      v-if="user.permissao === 0"
      xs10
      md2
      class="v-chip-link">
      <v-chip
        color="green"
        dark
        small
        style="cursor: pointer;"
        href="javascript:void()"
        @click="mudarEmpresa()"
      >
        {{ strings[idioma].mudar_empresa }}
      </v-chip>
    </v-flex>
  </v-layout>
</template>
<script>
import { mapState } from 'vuex'
export default {
  props: {
    // eslint-disable-next-line vue/require-default-prop
    empresa: Object
  },
  data: () => ({
    logo: null
  }),
  computed: {
    ...mapState('app', ['strings', 'idioma', 'user', 'ingredientes', 'optionsNumber', 'alimentos_selecionados', 'categorias_alimentos', 'alert', 'dietas', 'predicoes', 'tabelas']),
    Cargos () {
      let cargos = [
        { 'nome': this.strings[this.idioma]['empresa_gestor'], 'nivel': 0, 'id': 'empresa_gestor' },
        { 'nome': this.strings[this.idioma]['empresa_gerente_regional'], 'nivel': 1, 'id': 'empresa_gerente_regional' },
        { 'nome': this.strings[this.idioma]['empresa_tecnico_venda'], 'nivel': 2, 'id': 'empresa_tecnico_venda' },
        { 'nome': this.strings[this.idioma]['empresa_produtor_vinculado'], 'nivel': 3, 'id': 'empresa_produtor_vinculado' }
      ]
      if (this.user.emp_user && this.user.emp_user.acesso > 0 && this.user.permissao !== 0) {
        cargos = cargos.filter(c => c.nivel > this.user.emp_user.acesso)
      }
      return cargos
    }
  },
  created () {
    this.getLogo()
  },
  methods: {
    getLogo () {
      this.axios.post('empresa/getLogo', { id: this.empresa.id }).then(res => {
        this.logo = res.data.data
      })
      return this.logo
    },
    go (url) {
      window.location.href = url
    },
    mudarEmpresa () {
      sessionStorage.removeItem('empresaAdm')
      this.go('/empresa')
    }
  }
}
</script>
